// Contrail V3.6.0 — slogans for the login map panel (approved text, Login Background dev brief R1.1).
// Edit freely: `lead` is white, `accent` is brand blue with a blinking cursor, `sub` is the supporting line.
export type Slogan = { lead: string; accent: string; sub: string };

export const LOGIN_SLOGANS: Slogan[] = [
  { lead: "Know where everything is.", accent: "Right now.", sub: "Vehicles, vessels and equipment across Fiji. Built, hosted and supported locally by Skyward Industries." },
  { lead: "Every vehicle. Every vessel.", accent: "One live map.", sub: "From Lautoka to Suva and out to the Yasawas, see your whole fleet move as it happens." },
  { lead: "Your fleet, on land", accent: "and at sea.", sub: "Live positions, trip history and alerts for vehicles and vessels, all in one place." },
  { lead: "Built in Fiji.", accent: "Tracking all of Fiji.", sub: "Designed, hosted and supported locally by Skyward Industries." },
  { lead: "Know the moment", accent: "something changes.", sub: "Zone, speed and offline alerts reach you in the app or by email as they happen." },
];

export const SLOGAN_ROTATE_MS = 8000;

/** A random index different from `current` (any index when current is -1). */
export function nextSlogan(current: number, n = LOGIN_SLOGANS.length) {
  if (n <= 1) return 0;
  if (current < 0) return Math.floor(Math.random() * n);
  let i = Math.floor(Math.random() * (n - 1));
  if (i >= current) i += 1;
  return i;
}
